module.exports = "import React from 'react';\nimport AppBar from 'material-ui/lib/app-bar';\n\nconst AppBarExampleIcon = React.createClass({\n  render() {\n    return (\n      <AppBar\n        title=\"Title\"\n        position=\"static\"\n        iconClassNameRight=\"muidocs-icon-navigation-expand-more\"\n      />\n    );\n  },\n});\n\nexport default AppBarExampleIcon;\n"


/*****************
 ** WEBPACK FOOTER
 ** ./~/raw-loader!./src/app/components/AppBar/ExampleIcon.jsx
 ** module id = 753
 ** module chunks = 0
 **/